import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import './soporte.css';

// TODO: Reemplazar los placeholders [INSERTAR_...] con los datos reales de Coralan Multiservice SRL
// antes del deploy a producción.
const CHANNELS = [
    {
        icon: 'fas fa-envelope',
        title: 'Correo Electrónico',
        contact: 'info@coralanmultiservice.com',
        hours: 'Lunes a Viernes, 8:00 AM – 6:00 PM',
        desc: 'Canal principal para consultas e incidencias no urgentes.',
        ctaText: 'Enviar correo',
        ctaIcon: 'fas fa-paper-plane',
        href: 'mailto:info@coralanmultiservice.com',
        urgent: false,
    },
    {
        icon: 'fab fa-whatsapp',
        title: 'WhatsApp Empresarial',
        contact: '18096050699',
        hours: 'Lunes a Viernes, 8:00 AM – 6:00 PM',
        desc: 'Respuestas rápidas para consultas durante horas hábiles.',
        ctaText: 'Abrir WhatsApp',
        ctaIcon: 'fab fa-whatsapp',
        // TODO: reemplazar con número real (formato wa.me/<número>)
        href: 'https://wa.me/18096050699',
        urgent: false,
    },
    // {
    //     icon: 'fas fa-phone-alt',
    //     title: 'Teléfono Directo',
    //     contact: '[INSERTAR_TELÉFONO_SOPORTE]',
    //     hours: 'Lunes a Viernes, 8:00 AM – 6:00 PM',
    //     desc: 'Atención telefónica directa con nuestro equipo técnico.',
    //     ctaText: 'Llamar ahora',
    //     ctaIcon: 'fas fa-phone-alt',
    //     href: 'tel:[INSERTAR_TELÉFONO_SOPORTE]',
    //     urgent: false,
    // },
    // {
    //     icon: 'fas fa-exclamation-triangle',
    //     title: 'Línea de Emergencias 24/7',
    //     contact: '[INSERTAR_TELÉFONO_EMERGENCIAS]',
    //     hours: '24 horas / 7 días — Solo incidencias críticas',
    //     desc: 'Para fallos críticos que impidan la emisión de comprobantes.',
    //     ctaText: 'Llamar (urgente)',
    //     ctaIcon: 'fas fa-phone-alt',
    //     href: 'tel:[INSERTAR_TELÉFONO_EMERGENCIAS]',
    //     urgent: true,
    // },
];

const SLA = [
    {
        level: 'P1',
        title: 'Crítica',
        color: 'p1',
        situation:
            'El servicio está completamente inoperativo. No puede emitir ningún e-CF.',
        response: '30 minutos',
        resolution: '4 horas',
        availability: '24/7',
    },
    {
        level: 'P2',
        title: 'Alta',
        color: 'p2',
        situation:
            'Fallo parcial del servicio. Impacto significativo en la emisión de e-CF.',
        response: '2 horas',
        resolution: '8 horas',
        availability: 'Horas hábiles',
    },
    {
        level: 'P3',
        title: 'Media',
        color: 'p3',
        situation:
            'Funcionalidad degradada. Existe solución alternativa temporal.',
        response: '4 horas hábiles',
        resolution: '2 días hábiles',
        availability: 'Horas hábiles',
    },
    {
        level: 'P4',
        title: 'Baja',
        color: 'p4',
        situation:
            'Consultas, información o errores menores sin impacto operativo.',
        response: '8 horas hábiles',
        resolution: '5 días hábiles',
        availability: 'Horas hábiles',
    },
];

const STEPS = [
    'Contacta por cualquier canal',
    'Recibes un número de caso único',
    'Nuestro equipo evalúa y asigna prioridad',
    'Te mantenemos informado del progreso',
    'Confirmamos la resolución contigo',
];

const Soporte = () => {
    return (
        <LegalPageLayout
            seoTitle="Soporte técnico y mesa de ayuda"
            path="/soporte"
            description="Soporte técnico de Coralan Multiservice para facturación electrónica y software: canales de contacto, horarios y niveles de servicio (SLA)."
            breadcrumbLabel="Soporte"
            title="Soporte y Asistencia Técnica"
            subtitle="Mesa de ayuda para contribuyentes. Estamos aquí para ayudarte — selecciona el canal que mejor se adapte a tu necesidad."
        >
            {/* Urgent CTA banner */}
            <div className="soporte-urgent">
                <div className="soporte-urgent__text">
                    <i className="fas fa-bolt soporte-urgent__icon" aria-hidden="true"></i>
                    <div>
                        <p className="soporte-urgent__title">
                            ¿Tienes un problema urgente que impide emitir e-CF?
                        </p>
                        <p className="soporte-urgent__subtitle">
                            Llama a nuestra línea de emergencias 24/7.
                        </p>
                    </div>
                </div>
                {/* TODO: reemplazar con teléfono real */}
                <a href="tel:[INSERTAR_TELÉFONO_EMERGENCIAS]" className="soporte-urgent__btn">
                    <i className="fas fa-phone-alt" aria-hidden="true"></i>
                    Llamar ahora
                </a>
            </div>

            {/* Channels */}
            <div className="soporte-section">
                <div className="soporte-section-heading">
                    <span className="soporte-section-heading__label">Canales de Contacto</span>
                    <h2 className="soporte-section-heading__title">¿Cómo prefieres contactarnos?</h2>
                    <p className="soporte-section-heading__subtitle">
                        Atendemos por múltiples canales para que recibas la ayuda que necesitas, cuando la necesitas.
                    </p>
                </div>

                <div className="row">
                    {CHANNELS.map((c) => (
                        <div className="col-12 col-md-6 mb-4" key={c.title}>
                            <div
                                className={`soporte-channel-card${
                                    c.urgent ? ' soporte-channel-card--urgent' : ''
                                }`}
                            >
                                <div className="soporte-channel-card__icon-wrap">
                                    <i className={`${c.icon} soporte-channel-card__icon`} aria-hidden="true"></i>
                                </div>
                                <h3 className="soporte-channel-card__title">{c.title}</h3>
                                <p className="soporte-channel-card__contact">{c.contact}</p>
                                <p className="soporte-channel-card__hours">{c.hours}</p>
                                <p className="soporte-channel-card__desc">{c.desc}</p>
                                <a
                                    href={c.href}
                                    className="soporte-channel-card__cta"
                                    target={c.href.startsWith('http') ? '_blank' : undefined}
                                    rel={c.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                                >
                                    <i className={c.ctaIcon} aria-hidden="true"></i>
                                    {c.ctaText}
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* SLA */}
            <div className="soporte-section">
                <div className="soporte-section-heading">
                    <span className="soporte-section-heading__label">SLA</span>
                    <h2 className="soporte-section-heading__title">Tiempos de Respuesta</h2>
                    <p className="soporte-section-heading__subtitle">
                        Clasificamos cada caso según su impacto para garantizar tiempos de respuesta y resolución.
                    </p>
                </div>

                <div className="soporte-sla-grid">
                    {SLA.map((s) => (
                        <div className="soporte-sla-card" key={s.level}>
                            <div className={`soporte-sla-card__header soporte-sla-card__header--${s.color}`}>
                                <div className="soporte-sla-card__level">Nivel {s.level}</div>
                                <h3 className="soporte-sla-card__title">{s.title}</h3>
                            </div>
                            <div className="soporte-sla-card__body">
                                <p className="soporte-sla-card__situation">{s.situation}</p>
                                <div className="soporte-sla-card__row">
                                    <span className="soporte-sla-card__row-label">Respuesta</span>
                                    <span className="soporte-sla-card__row-value">{s.response}</span>
                                </div>
                                <div className="soporte-sla-card__row">
                                    <span className="soporte-sla-card__row-label">Resolución</span>
                                    <span className="soporte-sla-card__row-value">{s.resolution}</span>
                                </div>
                                <div className="soporte-sla-card__row">
                                    <span className="soporte-sla-card__row-label">Soporte</span>
                                    <span className="soporte-sla-card__row-value">{s.availability}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Process */}
            <div className="soporte-section">
                <div className="soporte-section-heading">
                    <span className="soporte-section-heading__label">Proceso</span>
                    <h2 className="soporte-section-heading__title">¿Cómo funciona el soporte?</h2>
                    <p className="soporte-section-heading__subtitle">
                        Un proceso sencillo y transparente desde el primer contacto hasta la resolución.
                    </p>
                </div>

                <div className="soporte-stepper">
                    {STEPS.map((text, idx) => (
                        <div className="soporte-step" key={idx}>
                            <div className="soporte-step__num">{idx + 1}</div>
                            <p className="soporte-step__text">{text}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Availability */}
            <div className="soporte-availability">
                <h3 className="soporte-availability__title">
                    <i className="fas fa-server" aria-hidden="true"></i>
                    Disponibilidad del Servicio
                </h3>
                <p className="soporte-availability__metric">99.5% <span style={{ fontSize: 16, color: '#666', fontWeight: 600 }}>mensual garantizado</span></p>
                <p className="soporte-availability__caption">
                    Los mantenimientos programados se notifican con al menos 48 horas de anticipación.
                </p>
            </div>
        </LegalPageLayout>
    );
};

export default Soporte;
